import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { dataUrlToBlob, uploadProfileImageFor } from '../utils/imageApi';
import { validateSession } from  '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { getSelectedBranchId } from '../utils/branch';
import { isValidEmail, EMAIL_INVALIDO_MSG } from '../utils/email';

var config = process.env;

class AddAdminPage extends Component {

	constructor(){
        super();
        this.state = {
            checked: false,
            disabled: false,
            src: "./images/empty-user.png",
            empty: "./images/empty-user.png"
        }
	}

    async componentDidMount() {
        let role = await validateSession()
        this.setState({ checked: true, role:  role});
    }

    redirect = () => {
        navigateTo('/accessories');
    }

    checkIsValid = (input) => {
        if (input.value == null || input.value == undefined || input.value == '') {
            input.className = "form-control is-invalid";
            return true;
        } else {
            input.className = "form-control";
            return false;
        }
    }

    // Acá el email SÍ es obligatorio (a diferencia de la ficha de cliente): es la
    // identidad del admin —se le manda el mail de bienvenida y es la clave con la
    // que se sube su foto—. Lo que cambia es que además tiene que tener FORMA de
    // dirección: "no vacío" dejaba pasar cualquier cosa y el mail de bienvenida
    // terminaba marcado como fallado.
    checkEmailIsValid = (input) => {
        if (isValidEmail(input.value)) {
            input.className = "form-control";
            return false;
        }
        input.className = "form-control is-invalid";
        return true;
    }

    onClickSave = () => {
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var email = document.getElementById("email");
        var phone = document.getElementById("phone");
        var role = document.getElementById("role");
        
        var hasError = false;
        hasError = this.checkIsValid(firstName) || hasError;
        hasError = this.checkIsValid(lastName) || hasError;
        hasError = this.checkEmailIsValid(email) || hasError;
        hasError = this.checkIsValid(phone) || hasError;

        if (!hasError) {
            const selectedBranchId = getSelectedBranchId();
            if (!selectedBranchId || selectedBranchId === 'all') {
                alert('Seleccioná una sucursal específica para crear el administrador.');
                return;
            }

            this.setState({ disabled: true });
            var token = localStorage.getItem('token');
            var request = {
                method: 'POST',
                headers: { 
                'Content-Type': 'application/json',
                'access-token': token
                },
                body: JSON.stringify({
                    firstName: firstName.value,
                    lastName: lastName.value,
                    email: email.value,
                    phone: phone.value,
                    role: parseInt(role.value)
                })
            };
            fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}admin?branchId=${selectedBranchId}`, request)
            .then(results => { return results.json(); })
            .then(data => {
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ disabled: false });
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    this.uploadImage(email.value);
                }
            });
        } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    // La foto es de OTRO admin (el que se acaba de crear), así que va por la ruta con email.
    uploadImage = (email) => {
        if (this.state.src != this.state.empty) {
            dataUrlToBlob(this.state.src)
            .then(blob => uploadProfileImageFor(email, blob))
            .then(() => {
                this.redirect();
            })
            .catch(error => {
                // El admin YA quedó creado: se avisa que falló la foto, pero se redirige igual
                // para no dejar el formulario habilitado y que lo vuelvan a dar de alta.
                alert(error.message);
                this.redirect();
            });
        } else {
            this.redirect();
        }
    }

    redirect = () => {
        navigateTo('/admin');
    }
    
    onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        try {
            const reader = new FileReader();
            reader.onload = () => {
              this.setState({ src: reader.result });
            };
            reader.readAsDataURL(files[0]);
        } catch (error) {}
    }

    handleClickFile = () => {
        document.getElementById("file").click();
    }

	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={7} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />                            
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Dashboard" subtitle="Agregar administrador"/>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="card card-small mb-4 pt-3" style={{borderRadius: '.625rem', padding: '15px'}}>
                                            <div className="text-center">
                                                <div className="mb-3 mx-auto">
                                                    <img className="rounded-circle" src={this.state.src} alt="User Avatar" width="110" />
                                                </div>
                                                <span className="text-muted d-block mb-2">Imágen de perfil</span>
                                                <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={ this.onChange }/>
                                                <button 
                                                    onClick={() => this.handleClickFile()} 
                                                    type="button" 
                                                    style={{marginTop: '10px'}}
                                                    className="mb-2 btn btn-sm btn-pill btn-outline-primary mr-2">
                                                    <i class="material-icons mr-1">file_upload</i>
                                                    Subir
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="card card-small mb-4">
                                            <div className="card-header border-bottom">
                                                <h6 className="m-0">Datos personales</h6>
                                            </div>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item p-3">
                                            <div className="row">
                                                <div className="col">
                                                    <div className="form-row">
                                                        <div className="form-group col-md-6">
                                                            <label for="firstName">Nombre</label>
                                                            <input type="text" className="form-control" id="firstName" placeholder="Ingrese nombre/s" />
                                                        </div>
                                                        <div className="form-group col-md-6">
                                                            <label for="lastName">Apellido</label>
                                                            <input type="text" className="form-control" id="lastName" placeholder="Ingrese apellido/s" />
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-5">
                                                            <label for="email">Email</label>
                                                            <input type="email" className="form-control" id="email" placeholder="Ingrese el correo" />
                                                            <div className="invalid-feedback">{ EMAIL_INVALIDO_MSG }</div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label for="phone">Teléfono</label>
                                                            <input type="text" className="form-control" id="phone" placeholder="Ingrese el teléfono" />
                                                        </div>
                                                        <div className="form-group col-md-3">
                                                            <label>Rol</label>
                                                            <select id="role" className="custom-select">
                                                                <option value="1">Administrador</option>
                                                                <option value="2">Encargado</option>
                                                                <option value="4">Finanzas</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer border-top">
                                                        <button onClick={() => this.onClickSave()} 
                                                                type="button" 
                                                                className="mb-2 btn btn-primary mr-2" 
                                                                style={{float: 'right'}} 
                                                                disabled={this.state.disabled}>
                                                                Guardar
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default AddAdminPage;
